import React from 'react';
import styled from 'styled-components';

const ButtonShell = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    background: ${props => props.theme.colors.primary};
    color: #fff;
    margin-bottom: 10px;
    border: 1px solid #B7B7B7;
    box-sizing: border-box;
    border-radius: 5px;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    height: 75px;
    cursor: pointer;
    user-select: none;
    overflow: hidden;

    &:hover {
        div:first-of-type {
            div:first-of-type {
                transform: scale(1.2);
                transition: all .25s;
                transition-timing-function: ease-in-out;
            }
        }
    }
`;

const IconShell = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #81BFE2;
    width: 75px;
    height: 100%;
    border-right: solid 1px #009EDC;
    margin-right: 15px;
    ::after {
        display: block;
        content: "";
        font-weight: bold;
        height: 75px;
        position: absolute;
        left: 89px;
        border-right: 1px solid #0263B9;
    }
`;

const Icon = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: #00245C;
    transform: scale(1); 
    transition: all .25s;
    transition-timing-function: ease-in-out;
    ::after {
        content: "+";
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        border-radius: 50px;
        width: 22px;
        height: 22px;
        background: #fff;
        color: ${props => props.theme.colors.positive};
        border: 2px solid #81BFE2;
        position: absolute;
        top: 17px;
        left: 21px;

    }
`;

const CreateNewButton = ({ type, icon, onClick }) => (
    <ButtonShell onClick={onClick} >
        <IconShell>
            <Icon className={`icon-${icon}`} />
        </IconShell>
        Create New {type}
    </ButtonShell>
);

export default CreateNewButton;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/CreateNewButton.js